import { FunctionComponent } from "react";
import styled from "styled-components";
import Image from "next/image";

import { H1 } from "@/components/Typography";
import { colours } from "@/utils";
import { Device } from "@/utils/device";

type StyleProps = {
  secondText?: boolean;
};

const AboutHeader: FunctionComponent = () => {
  return (
    <S.Section>
      <S.Title>
        Redefining
        <S.BoldWrap>ambition</S.BoldWrap>
      </S.Title>
      <S.ImageContainer>
        <Image
          src="/images/allbright-summit/summit-microphone-on-chair.jpg"
          alt="AllBright microphone lying on yellow velvet chair"
          layout="fill"
          objectFit="cover"
        />
      </S.ImageContainer>
      <S.Title secondText>
        Transforming
        <S.BoldWrap>businesses</S.BoldWrap>
      </S.Title>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  margin-top: 2rem;
  align-content: center;
`;

S.Title = styled(H1)<StyleProps>`
  padding: 2.5rem 10%;
  font-family:
    Roxborough CF,
    sans-serif;
  font-size: 6rem;
  font-weight: 100;
  font-style: italic;
  line-height: 5rem;
  letter-spacing: -1px;
  text-align: center;
  color: ${colours.marketingNavy};

  @media (min-width: ${Device.tablet}) {
    text-align: ${(p) => (p.secondText ? "right" : "left")};
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 11.8rem;
    line-height: 9.5rem;
  }
`;

S.BoldWrap = styled.span`
  font-family:
    HK Grotesk,
    sans-serif;
  font-weight: 800;
  font-style: normal;
  letter-spacing: -2px;
  margin-left: 6rem;
  display: block;

  @media (min-width: ${Device.desktop}) {
    padding-left: 50px;
  }
`;

S.ImageContainer = styled.div`
  height: 21rem;
  width: 100%;
  position: relative;

  @media (min-width: ${Device.desktop}) {
    height: 28rem;
  }
`;

export default AboutHeader;
